<template>
    <q-layout view="lhr lpr lfr">
        <q-header elevated>
            <gfk-header :title="siteTitle" :subtitle="siteSubtitle">
                <template #right-top>
                    <router-link :to="{name:'caseidStart'}">Home</router-link> |
                    Logged in as <strong>{{ userDisplayName }}</strong> |
                    <router-link :to="{name: 'logout'}">Log out</router-link>
                </template>
                <template #customer-logo>
                    <div  class="customer-logo" style="width:25em; font-family:monospace; color:#fff !important" >
                        <q-input label-color="white" filled inverted readonly v-model="activeCaseId" @click="$event.target.select()" label="Case Id" class="gfk-bg-primary gfk-q-input" ></q-input>
                    </div>
                </template>
            </gfk-header>
        </q-header>
        <q-page-container>
            <q-page>
                <div class="row xs-gutter">
                    <div class="col-lg-12" style="width:100%">
                        <q-card class="bg-white no-margin justify-center">
                            <q-card-section>
                                <div class="row items-center justify-center sm-gutter">
                                    <div style="width:50%" >
                                    <q-banner color="blue" icon="warning" class="bg-primary text-white q-alert shadow-2 bg-blue text-white gfk-banner">
                                        <template v-slot:avatar>
                                            <q-icon name="warning" color="white" size="1.5rem" />
                                        </template>
                                        Please use as many fields as possible. The search will be performed on all search criteria combined.
                                    </q-banner>
                                    <div style="margin-top: 50px">
                                        <q-field><q-input v-model="lastName" class="IDlastName" stack-label label="Last Name (optional)" /></q-field>
                                        <q-field><q-input v-model="firstName" class="IDfirstName" stack-label label="First Name (optional)" /></q-field>
                                        <q-field><q-input v-model="email" class="IDemail" stack-label label="E-mail (optional)" /></q-field>
                                    </div>
                                    <div class="IDmoreFields">
                                        <p class="caption" style="margin-top:50px; color:#777777">More fields</p>
                                        <div v-for="attr in otherAttrs">
                                            <q-field>
                                                <div class="row no-wrap" style="width: 100%;">
                                                    <q-select v-model="attr.category" :options="categories" label="Category" clearable class="col-md-6 IDcategory search-category" @update:model-value="reviewModel"/>
                                                    <q-input v-model="attr.value" class="IDcriteria col-md-6 offset-md-1 search-criteria" label="Criteria" @input="reviewModel"/>
                                                </div>
                                            </q-field>
                                        </div>
                                    </div>
                                    <div class="row justify-center" style="margin-top: 50px">
                                        <q-btn color="blue-10" class="full-width IDsearchAllSystems" label="Search all systems" @click="beginSearch" />
                                    </div>
                                    </div>
                                </div>
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </q-page>
        </q-page-container>
        <q-footer class="q-layout-footer">
            <gfk-footer/>
        </q-footer>
        <template>
            <div class="q-pa-md q-gutter-sm">
                <q-dialog v-model="fixed">
                    <q-card>
                        <q-card-section class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar>
                                <q-toolbar-title>Confirm</q-toolbar-title>
                            </q-toolbar>
                        </q-card-section>
                        <q-card-section style="max-height: 50vh" class="scroll dialog-main-content">
                                <p class="caption">
                                    You are going to perform a search with the following criteria:
                                </p>
                                <q-list separator>
                                    <template v-for="attr in cleanedAttrs">
                                        <q-item clickable v-ripple>
                                            <q-item-section>{{attr.category.value ||  attr.category}}: {{attr.value}}</q-item-section>
                                        </q-item>
                                    </template>
                                </q-list>
                        </q-card-section>
                        <q-card-section elevated class="gfk-bg-primary text-white dialog-header-footer">
                                <q-toolbar slot="footer">
                                    <div class="row inline full-width justify-between">
                                        <div class="col-xs-4 col-md-3 col-lg-2"><q-btn flat @click="fixed=false" label="Go back" /></div>
                                        <div class="col-xs-4 col-md-3 col-lg-2" ><q-btn flat @click="performSearch" label="Proceed" /></div>
                                    </div>
                                </q-toolbar>
                        </q-card-section>
                    </q-card>
                </q-dialog>
            </div>
        </template>
        
    </q-layout>
</template>

<script>
	import {
        QLayout, QToolbar, QSelect, QInnerLoading, QSpinnerGears, QCard, QCardSection, QBtn, QInput, QField, QDialog, QBanner, QList, QItemLabel, QItem, QItemSection, QHeader, QPageContainer, QFooter, QPage, QIcon, QSeparator, QToolbarTitle
    } from 'quasar';
    import { ref } from 'vue';
	import authenticateApi from '../api/auth';
	import store from '../store';
	import {
        CASEID,
        CATEGORIES,
        PERFORM_SEARCH,
        LOAD_SEARCH_PROGRESS
	} from '../store/keys';

	import gfkHeader from './gfk-header.vue';
	import gfkFooter from './gfk-footer.vue';
	import siteData from '../mixins/site-data-mixin';
    const attrCleanup = (attrs) => _.filter(attrs, (attr) => !((attr.category === null || attr.category === '') && (attr.value === null || attr.value === '')));

	export default {
		mixins: [siteData],
		components: {
            QLayout,
			QToolbar,
			gfkHeader,
			gfkFooter,
			QSelect,
			QInnerLoading,
			QSpinnerGears,
            QCard,
            QCardSection,
            QBtn,
            QInput,
            QField,
            QDialog,
            QBanner,
            QList,
            QItemLabel,
            QItem,
            QItemSection,
            QHeader,
            QPageContainer,
            QFooter,
            QPage,
            QIcon,
            QSeparator,
            QToolbarTitle
        },
		props: {
			presetId: {
				type: String
			}
		},
		data() {
			return {
                fixed: false,
                lastName: '',
                firstName: '',
                email: '',
                otherAttrs: [{
                    value: null,
                    category: ''
                }]
			};
		},
		computed: {
			userDisplayName() {
				return authenticateApi.getUsername();
			},
            activeCaseId() {
                return store.getters[CASEID];
            },
            categories() {
                const toFilter = {
                    firstName: true,
                    lastName: true,
                    email: true,
                    other: true,
                    primaryKey: true
                };
                return _.filter(store.getters[CATEGORIES], (cat) => (_.isUndefined(toFilter[cat.value])));
            },
            cleanedAttrs() {
                const attrs = _.filter(attrCleanup(this.otherAttrs), (attr) => !_.isEmpty(attr.value));
                if (this.lastName) {
                    attrs.push({
                        value: this.lastName,
                        category: 'Last Name'
                    });
                }
                if (this.firstName) {
                    attrs.push({
                        value: this.firstName,
                        category: 'First Name'
                    });
                }
                if (this.email) {
                    attrs.push({
                        value: this.email,
                        category: 'E-mail'
                    });
                }
                return attrs;
            }
		},
		mounted() {

		},
        methods: {
            beginSearch() {
                if (_.isEmpty(this.cleanedAttrs)) {
                    this.$q.notify({
                        message: 'You have not supplied any search criteria',
                        type: 'negative',
                        position: 'bottom',
                        timeout: 1500,
                        actions: [
                            {
                                label: 'Dismiss'
                            }
                        ]
                    });
                } else {
                    this.fixed = true;
                }
            },
            reviewModel() {
                // clear all empty fields, add an empty one at the end
                const newAttrs = attrCleanup(this.otherAttrs);
                newAttrs.push({
                    value: '',
                    category: null
                });
                this.otherAttrs = newAttrs;
            },
            performSearch() {
                const searchCriteria = {};
                if (this.lastName) {
                   searchCriteria.lastName = this.lastName;
                }
                if (this.firstName) {
                   searchCriteria.firstName = this.firstName;
                }
                if (this.email) {
                   searchCriteria.email = this.email;
                }
                _.each(this.otherAttrs, ({value, category}) => {
                   if (value) {
                      searchCriteria[category.value] = value;
                   }
                });
                store.dispatch(PERFORM_SEARCH, searchCriteria).then(() => {
                    return store.dispatch(LOAD_SEARCH_PROGRESS);
                }).then(() => {
                        this.$router.replace({name: 'searchOverview'});
                });
            }
        }
	};
</script>
